import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=b8aff42a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8aff42a')) {
      api.createRecord('b8aff42a', component.options)
    } else {
      api.reload('b8aff42a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=b8aff42a&", function () {
      api.rerender('b8aff42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26jlLO5SEQX33/JS/comp/IncreaseNumber.vue"
export default component.exports